import { isMobile } from 'react-device-detect';

import { CustomSessionStorage } from '@/lib/storage/customSessionStorage';

const KEY_SHOW_WALLET = 'show-wallet-info';
const KEY_VIEWED_GUEST_MODAL = 'viewed-guest-modal';

export const ShowWalletInfoSessionStorage =
  CustomSessionStorage<boolean>(KEY_SHOW_WALLET);
export const ViewedGuestModalSessionStorage = CustomSessionStorage<boolean>(
  KEY_VIEWED_GUEST_MODAL,
);

export const getShowWalletInfo = () => {
  const tmp = ShowWalletInfoSessionStorage.get();
  if (tmp != null) {
    return tmp;
  }

  return isMobile;
};
